package compose.assets.svg

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import compose.assets.Svg

public val Svg.DownloadOutline: ImageVector
    get() {
        if (_downloadOutline != null) {
            return _downloadOutline!!
        }
        _downloadOutline = Builder(name = "DownloadOutline", defaultWidth = 24.0.dp, defaultHeight =
                24.0.dp, viewportWidth = 10.0f, viewportHeight = 10.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f,
                    strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                    pathFillType = NonZero) {
                moveTo(4.6667f, 7.0f)
                lineTo(1.75f, 4.0833f)
                lineTo(2.5667f, 3.2375f)
                lineTo(4.0833f, 4.7542f)
                verticalLineTo(0.0f)
                horizontalLineTo(5.25f)
                verticalLineTo(4.7542f)
                lineTo(6.7667f, 3.2375f)
                lineTo(7.5833f, 4.0833f)
                lineTo(4.6667f, 7.0f)
                verticalLineTo(7.0f)
                moveTo(1.1667f, 9.3333f)
                curveTo(0.8458f, 9.3333f, 0.5712f, 9.2191f, 0.3427f, 8.9906f)
                curveTo(0.1142f, 8.7621f, 0.0f, 8.4875f, 0.0f, 8.1667f)
                verticalLineTo(6.4167f)
                horizontalLineTo(1.1667f)
                verticalLineTo(8.1667f)
                verticalLineTo(8.1667f)
                verticalLineTo(8.1667f)
                horizontalLineTo(8.1667f)
                verticalLineTo(8.1667f)
                verticalLineTo(8.1667f)
                verticalLineTo(6.4167f)
                horizontalLineTo(9.3333f)
                verticalLineTo(8.1667f)
                curveTo(9.3333f, 8.4875f, 9.2191f, 8.7621f, 8.9906f, 8.9906f)
                curveTo(8.7621f, 9.2191f, 8.4875f, 9.3333f, 8.1667f, 9.3333f)
                horizontalLineTo(1.1667f)
                verticalLineTo(9.3333f)
            }
        }
        .build()
        return _downloadOutline!!
    }

private var _downloadOutline: ImageVector? = null
